import React, { useState, useEffect, useCallback } from 'react';
import axios from '../../api/api';
import { toast } from 'sonner'
import Pagination from '../Pagination';
import { MdOutlineBlock, MdEdit } from 'react-icons/md';
import Loader from '../Loader';
import { Link } from 'react-router-dom'

const ScheduleBundle = () => {

  const [account_number, setAccount_number] = useState('')
  const [amount, setAmount] = useState('')
  const [client_id, setClient_id] = useState('')
  const [service_type, setService_type] = useState('DATA')
  const [request_push_time, setRequest_push_time] = useState('')
  const [listaccounts, setListaccounts] = useState([])
  const [transaction, setTransaction] = useState([]);
  const [searchAccountNumber, setSearchAccountNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [count, setCount] = useState(0)
  const [total, setTotal] = useState(0)
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [bundle, setBundle] = useState([])

  // Fetch user accounts
  const getAccounts = useCallback(async () => {
    try {
      const response = await axios.get('/service_clients/?service_ref_id=5');
      setListaccounts(response.data.items)
    } catch (error) {
      console.log(error);
    }
  }, []);

  // Fetch bundle products
  // const getBundles = useCallback(async () => {
  //   try {
  //     const response = await axios.get('/bundles/');
  //     setBundle(response.data.items)
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }, []);

  useEffect(() => {
    getAccounts()
  }, [getAccounts]);

  // Buy bundle request
  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsloading(true);
    try {
      const response = await axios.post('/batch_request/schedule',
        { account_number, amount, client_id, service_type, request_push_time }
      )
      toast.success(response.data.message)
      setAccount_number('')
      setAmount('')
      setClient_id('')
      setService_type('')
      setRequest_push_time('')
      getTransactions((currentPage - 1) * recordsPerPage, recordsPerPage);
    } catch (error) {
      console.log(error)
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else if (error.response.status === 400) {
        toast.error(error.response.data.detail)
      } else {
        toast.error('Oops! Something went wrong. Schedule failed.')
      }
    } finally {
      setLoading(false);
    }
  }


  // Convert date to partition format (pYYYYMMDD)
  const formatDateToPartition = (date) => {
    const d = new Date(date);
    return `p${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
  };

  // Fetch bundle transactions
  const getTransactions = useCallback(async (offset, limit) => {
    try {
      let query = `?offset=${offset}&limit=${limit}&service_id=5`

      if (startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        // Check if endDate is before startDate
        if (end < start) {
          alert('End date cannot be earlier than start date');
          setLoading(false);
          return;
        }
        const diffTime = Math.abs(end - start);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays > 32) {
          alert('Date range cannot exceed 32 days');
          setLoading(false);
          return;
        }

        const partitions = [];
        let current = new Date(startDate);

        // Handle case when start and end are the same
        if (diffDays === 0) {
          let current = new Date(startDate);
          current.setDate(current.getDate() + 1);
          partitions.push(formatDateToPartition(current));
        } else {
          while (current <= end) {
            current.setDate(current.getDate() + 1);
            partitions.push(formatDateToPartition(current));
          }
        }
        query += `&partitions=${partitions.join(',')}`;
      } else if (startDate) {
        const partitions = [];
        let current = new Date(startDate);
        current.setDate(current.getDate() + 1);
        partitions.push(formatDateToPartition(current));
        query += `&partitions=${partitions.join(',')}`;
      }

      if (searchAccountNumber) query += `&account_number=${searchAccountNumber}`;

      const response = await axios.get(`/batch_request/scheduled${query}`);
      setTransaction(response.data.items);
      setCount(response.data.count)
      setTotal(response.data.total)
      setLoading(false);
      setError(null);
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (!error.response) {
        setError("Network error! Check your connection.");
      } else if (error.response.status) {
        setError(error.response.data.detail)
      } else if (error.response.status >= 500) {
        setError("Server error! Please try again later.");
      } else {
        setError("An unexpected error occurred!");
      }
    }
  }, [startDate, endDate, searchAccountNumber]);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setLoading(true);
      getTransactions((currentPage - 1) * recordsPerPage, recordsPerPage, searchAccountNumber);
    }, 1000);
    return () => clearTimeout(timerId);
  }, [currentPage, recordsPerPage, getTransactions, searchAccountNumber]);

  return (
    <div className='mx-auto p-4'>
      <h4><b>Schedule Bundle Request</b></h4>
      <section className="bg-white p-4 rounded-lg my-2">
        <form onSubmit={handleSubmit}>
          <div className='p-2 w-full'>
            <label htmlFor='service'><span>Service Type</span>
              <input
                type='text'
                required
                disabled
                placeholder='service'
                className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                value={service_type}
                onChange={(e) => setService_type(e.target.value)}
              />
            </label>
          </div>
          <div className="flex flex-wrap items-center">
            <div className='p-2 w-full lg:w-1/2'>
              <label htmlFor='number'><span>Phone Number</span>
                <input
                  type='number'
                  required
                  placeholder='070000000'
                  className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                  value={account_number}
                  onChange={(e) => setAccount_number(e.target.value)}
                />
              </label>
            </div>
            <div className='p-2 w-full lg:w-1/2'>
              <label htmlFor='amount'><span>Bundle Amount</span>
                <select 
                  name="service" id="service"
                  className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                >
                  <option value="">Select..</option>
                  {/* {bundle.map((bundles) => (
                    <option key={bundles.id} value={bundles.value}>{bundles.code}</option>
                  ))} */}
                  <option value="100">100MB@100</option>
                </select>
              </label>
            </div>
          </div>
          <div className="flex flex-wrap items-center">
            <div className='p-2 w-full lg:w-1/2'>
              <label htmlFor='clientid'><span>Account</span>
                <select 
                  name="service" id="service"
                  className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                  value={client_id}
                  onChange={(e) => setClient_id(e.target.value)}
                >
                  <option value="">Select..</option>
                  {listaccounts.map((transaction) => (
                    <option key={transaction.id} value={transaction.client_id}>{transaction.client_id} - {transaction.units} units</option>
                  ))}
                </select>
              </label>
            </div>
            <div className='p-2 w-full lg:w-1/2'>
              <label htmlFor='date'><span>Date and Time</span>
                <input
                  type='datetime-local'
                  required
                  placeholder='datetime'
                  className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                  value={request_push_time}
                  onChange={(e) => setRequest_push_time(e.target.value)}
                />
              </label>
            </div>
          </div>
          <div className='my-4 text-center'>
            <button disabled={isloading} className='bg-[#134463] text-white px-5 py-2 rounded-lg text-md hover:bg-[#165277]'>{isloading ? 'Scheduling...' : 'Schedule Data'}</button>
          </div>
        </form>
      </section>

      <section className='mt-4'>
        <div className="bg-white rounded-lg p-4 w-full flex-1 min-w-0">
          <div className="flex flex-wrap items-center justify-between">
            <div>
              <form className='flex items-center flex-wrap'>
                <div className='p-2 w-full lg:w-1/3'>
                  <input
                    type='search'
                    className='px-3 py-1  w-full border bg-[#eef1ff] border-slate-300 rounded-md'
                    placeholder='Search account number'
                    value={searchAccountNumber}
                    onChange={(e) => setSearchAccountNumber(e.target.value)}
                  />
                </div>
                <label className='p-2 w-full lg:w-1/3' htmlFor="">
                  <span className='hidden'>Start Date</span>
                  <input 
                    type="date"
                    className='px-2 py-1 w-full border bg-[#f2f9ff] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#165277] focus:ring-[#165277] focus:ring-1'
                    value={startDate}
                    onChange={(e) => {setStartDate(e.target.value)}}
                  />
                </label>
                <label className='p-2  w-full lg:w-1/3' htmlFor="">
                  <span className='hidden'>End Date</span>
                  <input 
                    type="date" 
                    className='px-2 py-1  w-full border bg-[#f2f9ff] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#165277] focus:ring-[#165277] focus:ring-1'
                    value={endDate}
                    onChange={(e) => {setEndDate(e.target.value)}}
                  />
                </label>
              </form>
            </div>
            <h5 className='text-[#165277] font-bold my-4'>Showing {count} / {total} Scheduled Data requests</h5>
          </div>
          {loading ? (
            <div className='flex items-center justify-center bg-[#e9f3f9] h-[70vh]'>
              <Loader />
            </div>
          ) : error ? (
            <div className='bg-[#e9f3f9] grid place-items-center h-[70vh]'>
              <div className='grid place-items-center text-red-600 p-4'>
                <h3><MdOutlineBlock /></h3>
                <span>{error}</span>
              </div>
            </div>
          ) : (
            <div className='overflow-x-auto rounded-lg'>
              {transaction.length > 0
                ? (
                  <table className='w-full text-left table-auto'>
                    <thead>
                      <tr className='border-b border-slate-500'>
                        <th className='p-2'>No</th>
                        <th className='p-2'>Account Number</th>
                        <th className='p-2'>Amount</th>
                        <th className='p-2'>Client Id</th>
                        <th className='p-2'>Service Type</th>
                        <th className='p-2'>Processed</th>
                        <th className='p-2'>Request Push Time</th>
                        <th className='p-2'>Updated At</th>
                        <th className='p-2'>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transaction.map((trans) => (
                        <tr key={trans.id}>
                          <td className='p-2 '>{trans.id}</td>
                          <td className='p-2'>{trans.account_number}</td>
                          <td className='p-2'>{trans.amount}</td>
                          <td className='p-2'>{trans.client_id}</td>
                          <td className='p-2'>{trans.service_type}</td>
                          <td className='p-2'>{trans.processed}</td>
                          <td className='p-2'>{new Date(trans.request_push_time).toLocaleString("en-CA", { hour12: false })}</td>
                          <td className='p-2'>{new Date(trans.updated_at).toLocaleString("en-CA", { hour12: false })}</td>
                          <td className='p-2'><Link to={`/app/updatescheduled/${trans.id}`}><button className='bg-green-200 text-green-700 p-1 text-xl rounded-lg'><MdEdit /></button></Link></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className='bg-[#e9f3f9] text-[#134463] grid place-items-center h-[70vh]'>
                    <div className='grid place-items-center p-4'>
                      <h3><MdOutlineBlock /></h3>
                      <h4>No Data</h4>
                    </div>
                  </div>
                )}
            </div>
          )}
          <div className='flex flex-wrap items-center justify-between mt-4 gap-4'>
            <div>
              <span className='mr-2'>Records per page:</span>
              <select
                className='px-3 py-1 border bg-[#e9f3f9] border-slate-300 rounded-md focus:outline-none focus:border-[#165277] focus:ring-[#165277] focus:ring-1'
                value={recordsPerPage}
                onChange={(e) => {
                  setRecordsPerPage(parseInt(e.target.value, 10));
                  setCurrentPage(1);
                }}
              >
                <option value='10'>10</option>
                <option value='20'>20</option>
                <option value='50'>50</option>
                <option value='75'>75</option>
                <option value='100'>100</option>
              </select>
            </div>
            <Pagination
              nPages={Math.ceil(total / recordsPerPage)}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </div>
      </section>
    </div>
  )
}

export default ScheduleBundle
